import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IfCrAwareDirective } from './if-cr-aware/if-cr-aware.directive';
import {
  FlipperDisabledDirective,
  FlipperEnabledDirective,
} from './flipper-switch/flipper-switch.directive';
import {
  IfAgencyHasFeatureDirective,
  IfAgencyLacksFeatureDirective,
} from './feature-switch/feature-switch.directive';

@NgModule({
  declarations: [
    IfCrAwareDirective,
    FlipperEnabledDirective,
    FlipperDisabledDirective,
    IfAgencyHasFeatureDirective,
    IfAgencyLacksFeatureDirective,
  ],
  exports: [
    IfCrAwareDirective,
    FlipperEnabledDirective,
    FlipperDisabledDirective,
    IfAgencyHasFeatureDirective,
    IfAgencyLacksFeatureDirective,
  ],
  imports: [CommonModule],
})
export class ContextDirectivesModule {}
